<lcp-header *ngIf="fields" [isInverted]="!!fields['bannerColor']"></lcp-header>


<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section [ngClass]="[
        'lcp-section', 
        !!fields['bannerColor'] ? 'is-banner' : '',
        fields['bannerColor'] ? 'is-background-' + fields['bannerColor'] : ''
      ]">
      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <section>
      <div class="lcp-section-content">
        <div class="display-flex">
          <lcp-rich-text
            class="lcp-subheading flex-50-not-sm margin-bottom-80"
            [document]="fields['subheading']">
          </lcp-rich-text>
        </div>

        <div class="logos-filters-container">
          <div class="lcp-filters">
            <a class="lcp-filter"
              [class.is-active]="activeFilters.length == 0"
              (click)="handleSelectFilter(null)"
              [innerHtml]="lcpHelper.htmlFromRichText(anyFilterGroup.fields['display'])">
            </a>

            <a *ngFor="let filter of clientFilters"
              class="lcp-filter"
              [class.is-active]="filterIsActive(filter)"
              (click)="handleSelectFilter(filter)" >

              {{ filter.fields['display'] }}
            </a>

            <!-- <ng-container *ngFor="let filterGroup of filterGroups">
              <div *ngIf="filterGroup" class="lcp-filter-group"
                [class.is-active]="filterGroup.isActive || (activeFilters.length == 0 && !filterGroup.fields['items'])"
                [class.is-open]="filterGroup.isOpen"
                (click)="handleSelectFilterGroup(filterGroup)"
                [innerHtml]="lcpHelper.htmlFromRichText(filterGroup.fields['display'])">
              </div>
            </ng-container> -->
            <!-- <a *ngFor="let filter of activeFilterGroup.fields['items']"
              class="lcp-filter"
              [class.is-active]="filterIsActive(filter)"
              (click)="handleSelectFilter(filter)" >

              {{ filter.fields['display'] }}
            </a> -->
          </div>

          <!-- <div *ngIf="activeFilterGroup"
            class="lcp-filters">
            <a *ngFor="let filter of activeFilterGroup.fields['items']"
              class="lcp-filter"
              [class.is-active]="filterIsActive(filter)"
              (click)="handleSelectFilter(filter)" >

              {{ filter.fields['display'] }}
            </a>
          </div> -->
        </div>

        <div #logosContainerOuter class="logos-container-outer">

          <div class="logos-container"
            [ngClass]="['total-columns-' + totalColumns]">
            <section class="logos-logo" *ngFor="let logo of logos; let i = index"
              [attr.data-row]="logoRow[i]"
              [attr.data-column]="logoColumn[i]"
              (mouseenter)="handleHoverLogo(logo)">
              <!-- [ngClass]="'logo-index-' + i" -->
              <div class="logo-image-wrapper"
                [class.is-missing-image]="!logo.metadata['src']">

                <div class="logo-image-container">
                  <img *ngIf="logo.metadata['src']"
                  class="logo-image"
                  [src]="logo.metadata['src']"
                  height="50"
                  width="150">
                </div>
              </div>

              <div class="logo-card-info"
                [class.is-inverted]="logo.metadata['is-inverted']"
                [style.background-color]="logo.metadata['primary-color'] || logoCardInfoDefaultColor">
                <div class="logo-card-info-client ellipsis-100pct">
                  {{ logo.fields['name'] }}
                </div>
                <div class="logo-card-info-industry">
                  <ng-container *ngIf="logo.metadata">
                    <!-- {{ clientFilters.find(filter => filter.sys.id == logo.metadata.tags.find(tag => tag?.sys?.id)) }} -->
                    {{ logo.metadata['industry'] }}
                    <!-- {{ logo.metadata.tags.find('') }} -->
                    <!-- {{ logo.fields['industry'] | ellipsis:15 }} -->
                  </ng-container>
                  <!-- {{ logo.fields['industry'] | ellipsis:15 }} -->
                </div>
              </div>
            </section>
          </div>
        </div>


        <section *ngIf="!logos || logos.length == 0"
          class="lcp-placeholder"
          [innerHTML]="placeholder">

          <div class="img-placeholder"></div>
        </section>
      </div>
    </section>
  </ng-container>
</div> 